export var DARK_MODE_EVENT_NAME = 'DARK_MODE';
export var UPDATE_DARK_MODE_EVENT_NAME = 'UPDATE_DARK_MODE';